import React from "react";
import { isEqual } from "@util/utils";
import { RECEIVER_TYPE } from "@icoach/constants/dataEnums";
import { MemberField, NonMemberField, CrossMemberField, EmployeeField, ClubField } from "./receiverFields";

/**
 * 接收者欄位渲染器組件
 * 根據接收者類型渲染對應的欄位組件
 * 使用配置映射替代多個條件判斷
 * @param {Object} props
 * @param {string} props.receiverType - 接收者類型
 * @param {Object} props.fieldRef - 欄位 ref
 * @param {Object} props.resource - 資源配置
 * @param {boolean} props.readOnly - 是否唯讀
 * @param {Object} props.errorModule - 驗證錯誤資訊
 */
const ReceiverFieldRenderer = ({ receiverType, fieldRef, resource = {}, readOnly, errorModule = {} }) => {
	const { clubOptions = [], coachOptions: employeeOptions = [] } = resource;

	// 根據組件名稱渲染對應的欄位組件
	if (isEqual(receiverType, RECEIVER_TYPE.MEMBER)) {
		return <MemberField ref={fieldRef} readOnly={readOnly} errorModule={errorModule} />;
	}

	if (isEqual(receiverType, RECEIVER_TYPE.NONMEMBER)) {
		return <NonMemberField ref={fieldRef} readOnly={readOnly} errorModule={errorModule} />;
	}

	if (isEqual(receiverType, RECEIVER_TYPE.CROSSMEMBER)) {
		return <CrossMemberField ref={fieldRef} clubOptions={clubOptions} readOnly={readOnly} errorModule={errorModule} />;
	}

	if (isEqual(receiverType, RECEIVER_TYPE.COACH)) {
		return <EmployeeField ref={fieldRef} employeeOptions={employeeOptions} readOnly={readOnly} errorModule={errorModule} />;
	}

	if (isEqual(receiverType, RECEIVER_TYPE.CLUB)) {
		return <ClubField ref={fieldRef} clubOptions={clubOptions} readOnly={readOnly} errorModule={errorModule} />;
	}

	// 如果沒有匹配的類型，返回 null
	return null;
};

export default ReceiverFieldRenderer;
